import { createSlice } from "@reduxjs/toolkit";
import {
    getSupportListThunk,
    getSupportDetailsThunk,
    replySupportThunk,
    updateSupportStatusThunk,
    updateSupportNoteThunk
} from "../thunks/supportThunk";

const initialState = {
    tickets: [],
    total: 0,
    page: 1,
    limit: 20,
    selected: null
};

const supportSlice = createSlice({
    name: "support",
    initialState,
    reducers: {
        clearSelectedTicket: (state) => {
            state.selected = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSupportListThunk.fulfilled, (state, action) => {
                state.tickets = action.payload?.data || [];
                state.total = action.payload?.total || 0;
                state.page = action.payload?.page || 1;
                state.limit = action.payload?.limit || 20;
            })
            .addCase(getSupportDetailsThunk.fulfilled, (state, action) => {
                state.selected = action.payload?.data || null;
            })
            // After a successful write, refresh `selected` so the open dialog
            // reflects the latest reply/status/note immediately.
            .addCase(replySupportThunk.fulfilled, (state, action) => {
                if (action.payload?.data) state.selected = action.payload.data;
            })
            .addCase(updateSupportStatusThunk.fulfilled, (state, action) => {
                if (action.payload?.data) state.selected = action.payload.data;
            })
            .addCase(updateSupportNoteThunk.fulfilled, (state, action) => {
                if (action.payload?.data) state.selected = action.payload.data;
            });
    }
});

export const { clearSelectedTicket } = supportSlice.actions;
export default supportSlice.reducer;
